<template>
  <h3>
    <slot />
  </h3>
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped>
h3 {
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 32px;
  font-family: var(--font-family-serif);
  font-weight: 600;
  line-height: 40px;
  text-align: left !important; /* NOTE @chris Global leak. */
}

@media (max-width: 960px) {
  h3 {
    font-size: 26px;
    line-height: 34px;
  }
}
</style>
